<div class="container-politicy" [ngStyle]="{'grid-template-rows': showHeaderFooter ? '100px auto' : 'auto'}"
[ngClass]="{'rapidScore': contratacion}" >
  <app-header *ngIf="showHeaderFooter" class="header">
  </app-header>
  <div class="container-center" [ngClass]="{'rapidScore': contratacion}"
    [ngStyle]="{'background-color': showHeaderFooter && !contratacion ? '#F9FCFF' : '#ffffff'}" role = "main">
    <div class="scroll-container">
      <div class="step-container">
        <div class="step">
          <div class="number one">1</div>
          <h1 class="one">{{ 'TERMS.CONDITIONS.CHECK_TERMS_1' | translate }}</h1>
        </div>
        <div class="step">
          <div class="number two">2</div>
          <h1 class="two">{{ 'TERMS.CONDITIONS.CHECK_POLITY' | translate }}</h1>
        </div>
      </div>
      <div class="text-container" *ngIf="this.country == 'ES'" style="overflow-y: auto" tabindex="0">
        <h2 class="title-p" tabindex="0">{{ 'TERMS.CONDITIONS.CHECK_POLITY' | translate }}</h2>
        <div class="container" tabindex="0">
          <!--NO contrataciones-->
          <div *ngIf="!contratacion">
            <ol *ngIf="!login">
              <li>
                <h3>{{ 'TERMS.POLICYFILE.TITLEPART1' | translate }}</h3>
                <span [innerHTML]="'TERMS.POLICYFILE.PART1TEXT' | translate | safeHtml"></span>

              </li>
              <li>
                <h3>{{ 'TERMS.POLICYFILE.TITLEPART2' | translate }}</h3>
                <span [innerHTML]="'TERMS.POLICYFILE.PART2TEXT' | translate | safeHtml"></span>
                <p>{{ 'TERMS.POLICYFILE.TITLEPART4' | translate }}</p>
              </li>
              <li>
                <h3>{{ 'TERMS.POLICYFILE.TITLEPART3' | translate }}</h3>
                <p>{{ 'TERMS.POLICYFILE.TITLEPART6' | translate }}</p>

                <p>
                  <span [innerHTML]="'TERMS.POLICYFILE.PART3TEXT' | translate | safeHtml"></span>

                </p>
                <p>
                  <span [innerHTML]="'TERMS.POLICYFILE.PART4TEXT' | translate | safeHtml"></span>

                </p>

                <p>
                  <span [innerHTML]="'TERMS.POLICYFILE.PART5TEXT' | translate | safeHtml"></span>

                </p>

                <p>
                  <span [innerHTML]="'TERMS.POLICYFILE.PART6TEXT' | translate | safeHtml"></span>


                </p>

                <p>
                  <span [innerHTML]="'TERMS.POLICYFILE.PART7TEXT' | translate | safeHtml"></span>


                </p>
              </li>
              <li>
                <h3>{{ 'TERMS.POLICYFILE.TITLEPART7' | translate }}</h3>
                <span [innerHTML]="'TERMS.POLICYFILE.PART8TEXT' | translate | safeHtml"></span>
              </li>
              <li>
                <h3>{{ 'TERMS.POLICYFILE.TITLEPART5' | translate }}</h3>
                <span [innerHTML]="'TERMS.POLICYFILE.PART9TEXT' | translate | safeHtml"></span>
              </li>
            </ol>

            <!--registro de usuario-->
            <ol *ngIf="login">
              <li>
                <h3>{{ 'TERMS.POLICYFILE.TITLEPART1' | translate }}</h3>
                <span [innerHTML]="'TERMS.POLICYFILE.PART1TEXT' | translate | safeHtml"></span>
              </li>
              <li>
                <h3>{{ 'TERMS.POLICYFILE.TITLEPART2' | translate }}</h3>
                <span [innerHTML]="'TERMS.POLICYFILE.PART10TEXT' | translate | safeHtml"></span>
              </li>
              <li>
                <h3>{{ 'TERMS.POLICYFILE.TITLEPART3' | translate }}</h3>
                <p>{{ 'TERMS.POLICYFILE.TITLEPART6' | translate }}</p>

                <p>
                  <span [innerHTML]="'TERMS.POLICYFILE.PART3TEXT' | translate | safeHtml"></span>

                </p>
                <p>
                  <span [innerHTML]="'TERMS.POLICYFILE.PART4TEXT' | translate | safeHtml"></span>

                </p>

                <p>
                  <span [innerHTML]="'TERMS.POLICYFILE.PART5TEXT' | translate | safeHtml"></span>

                </p>

                <p>
                  <span [innerHTML]="'TERMS.POLICYFILE.PART6TEXT' | translate | safeHtml"></span>


                </p>

                <p>
                  <span [innerHTML]="'TERMS.POLICYFILE.PART7TEXT' | translate | safeHtml"></span>


                </p>
              </li>
              <li>
                <h3>{{ 'TERMS.POLICYFILE.TITLEPART7' | translate }}</h3>
                <span [innerHTML]="'TERMS.POLICYFILE.PART8TEXT' | translate | safeHtml"></span>
              </li>
              <li>
                <h3>{{ 'TERMS.POLICYFILE.TITLEPART5' | translate }}</h3>
                <span [innerHTML]="'TERMS.POLICYFILE.PART9TEXT' | translate | safeHtml"></span>
              </li>
            </ol>
          </div>
          <!--SI contrataciones-->
          <div *ngIf="contratacion">
            <ol class="engagement">
              <li>
                <h3>{{ 'TERMS.POLICYFILE.TITLEPART1' | translate }}</h3>
                <span [innerHTML]="'TERMS.POLICYFILE.PART11TEXT' | translate | safeHtml"></span>

              </li>
              <li>
                <h3>{{ 'TERMS.POLICYFILE.TITLEPART2' | translate }}</h3>
                <span [innerHTML]="'TERMS.POLICYFILE.PART12TEXT' | translate | safeHtml"></span>
              </li>
              <li>
                <h3>{{ 'TERMS.POLICYFILE.TITLEPART3' | translate }}</h3>
                <p>
                  <span [innerHTML]="'TERMS.POLICYFILE.PART13TEXT' | translate | safeHtml"></span>
                </p>
              </li>
              <li>
                <h3>{{ 'TERMS.POLICYFILE.TITLEPART8' | translate }}</h3>
                <p>
                  <span [innerHTML]="'TERMS.POLICYFILE.PART14TEXT' | translate | safeHtml"></span>
                </p>
              </li>
              <li>
                <h3>{{ 'TERMS.POLICYFILE.TITLEPART9' | translate }}</h3>
                <p>
                  <span [innerHTML]="'TERMS.POLICYFILE.PART15TEXT' | translate | safeHtml"></span>
                </p>
              </li>
              <li>
                <h3>{{ 'TERMS.POLICYFILE.TITLEPART10' | translate }}</h3>
                <span [innerHTML]="'TERMS.POLICYFILE.PART16TEXT' | translate | safeHtml"></span>
              </li>
              <li>
                <h3>{{ 'TERMS.POLICYFILE.TITLEPART5' | translate }}</h3>
                <span [innerHTML]="'TERMS.POLICYFILE.PART17TEXT' | translate | safeHtml"></span>
              </li>
            </ol>
          </div>
        </div>
      </div>

      <div *ngIf="showButton" class="button">
        <button type="submit" class="cancel" (click)="backView()">{{ 'TERMS.BUTTONS.CANCEL' | translate }}</button>
        <button type="submit" class="accept" (click)="agreePolity()">{{ 'TERMS.BUTTONS.ACCEPT' | translate }}</button>
      </div>

    </div>
  </div>
  <app-footer *ngIf="!contratacion && showHeaderFooter" class="footer" [colorItems]="'#ffffff'" [classSpecial]="true">
  </app-footer>
</div>
